import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import equip1 from "../assets/equipment/equip (1).jpg";
import equip2 from "../assets/equipment/equip (2).jpg";
import equip3 from "../assets/equipment/equip (3).jpg";
import equip4 from "../assets/equipment/equip (4).jpg";
import equip5 from "../assets/equipment/equip (5).jpg";
import equip6 from "../assets/equipment/equip (6).jpg";
import equip7 from "../assets/equipment/equip (7).jpg";
import equip8 from "../assets/equipment/equip (8).jpg";
import equip9 from "../assets/equipment/equip (9).jpg";
import equip11 from "../assets/equipment/equipment (1).jpeg";
import equip12 from "../assets/equipment/equipment (2).jpeg";
import equip13 from "../assets/equipment/equipment (3).jpeg";
import equip14 from "../assets/equipment/equipment (4).jpeg";
import equip15 from "../assets/equipment/equipment (5).jpeg";
import equip16 from "../assets/equipment/equipment (6).jpeg";
import equip17 from "../assets/equipment/equipment (7).jpeg";
import equip18 from "../assets/equipment/equipment (8).jpeg";
import equip19 from "../assets/equipment/equipment (9).jpeg";
import equip20 from "../assets/equipment/equipment (10).jpeg";


const galleryImages = [
    equip1,
    equip2,
    equip3,
    equip4,
    equip5,
    equip6,
    equip7,
    equip8,
    equip9,
    equip11,
    equip12,
    equip13,
    equip14,
    equip15,
    equip16,
    equip17,
    equip18,
    equip19,
    equip20,
];

function GalleryHeavyEqui() {

  const { pathname } = useLocation();
    React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant" // use "smooth" if you want animation
    });
  }, [pathname]);

    const navigate = useNavigate();
    const [selectedImage, setSelectedImage] = useState(null);
    return (
        <div className="min-h-screen bg-gray-950">
      <div className="bg-yellow-500 py-6 shadow-lg flex items-center justify-between px-6">
        <h1 className="text-center text-3xl md:text-4xl font-extrabold text-gray-900 tracking-wide">
          Heavy Equipments
        </h1>
        <button
          onClick={() => navigate(-1)}
          className="bg-gray-900 text-yellow-500 px-4 py-2 rounded-xl font-semibold hover:bg-gray-800 transition"
        >
          Go Back
        </button>
      </div>

      <div className="max-w-7xl mx-auto p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {galleryImages.map((src, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-2xl shadow-xl group cursor-pointer"
              onClick={() => setSelectedImage(src)}
            >
              <img
                src={src}
                alt={`Electrical project ${index + 11}`}
                className="w-full h-72 object-cover transform group-hover:scale-110 transition duration-500"
              />
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <button
              className="absolute top-2 right-2 text-white text-2xl font-bold"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
            <img
              src={selectedImage}
              alt="Selected project"
              className="w-full rounded-2xl shadow-2xl object-contain max-h-screen"
            />
          </div>
        </div>
      )}
    </div>
    );
}
export default GalleryHeavyEqui